<template>
  <div class="mt-3">
    <v-divider />
    <v-layout align-center class="green--text my-4">
      <h3>Autores</h3>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <span class="caption grey--text text--darken-1">Autoria</span>
        <v-select
          :items="authorshipTypes"
          item-text="text"
          item-value="value"
          :value="authorship"
          @change="$emit('update:authorship',$event)"
          solo
          class="thin-border"
        />
      </v-flex>
      
      <v-flex xs12 v-for="(author, index) in authors" :key="index">
        <span class="caption grey--text text--darken-1">{{getAuthorLabel(index)}}</span>
        <v-text-field 
        :value="author"
        @input="updateAuthors(index, $event || '')"
        clearable
        solo
        class="thin-border"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Option } from '@/models/Specialty'

export default {
  props: {
    value: {type: Array, default: ()=>([])},
    authorship: {type: String}
  },
  data(){
    return {
      }
    
  },
  computed: {
    authorshipTypes(){
      return Option.query().where('component', 'authors').get()
    },
    authors(){
      if(this.value.length === 0 || this.value[this.value.length - 1].length > 0){
        return [...this.value, ""]
      }
      return this.value
    },
  },
  methods: {
    updateAuthors(index, author){
      const newAuthors = [...this.authors];
      newAuthors[index] = author;
      this.$emit('input', newAuthors.filter((el => el.length > 0)))
    },
    getAuthorLabel(index){
      let authorType;
      authorType = (this.authorship !== 'first-author' && index === 0) ? 'first-author' : 'co-author';
      return (this.authorshipTypes.find((el)=>(el.value === authorType)) || {}).text || "Outro"
    },
  }
}
</script>